module.exports = __webpack_public_path__ + "static/media/notification.0b4ac1dc.ttf";